import React from 'react';
import volugraphLogo from '../assets/icons/Volugraph Logo.png';

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV === 'development') {
      console.error('[AppErrorBoundary]', error, info?.componentStack);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="protected-route-loading" role="alert">
        <div className="protected-route-loading-content">
          <img src={volugraphLogo} alt="Volugraph" className="protected-route-logo" />
          <p
            style={{
              margin: 0,
              maxWidth: '22rem',
              fontSize: '0.9rem',
              lineHeight: 1.5,
              color: '#1a1a1a',
              textAlign: 'center',
            }}
          >
            Something went wrong loading this page.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              marginTop: '0.5rem',
              padding: '0.6rem 1.25rem',
              border: 'none',
              borderRadius: '12px',
              background: '#1a1a1a',
              color: '#fff',
              fontSize: '0.85rem',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Reload page
          </button>
        </div>
      </div>
    );
  }
}
